import { createI18n } from 'vue-i18n'
import messages from '@/locales/getLang.js'

const lang = window.navigator.language

export default createI18n({
  legacy: false,
  locale: lang.indexOf('en') >= 0 ? 'en_US' : 'zh_CN',
  messages
})
